import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ScrollToBottomButtonProps {
  onClick: () => void;
  visible: boolean;
  unreadCount?: number;
}

export function ScrollToBottomButton({ onClick, visible, unreadCount = 0 }: ScrollToBottomButtonProps) {
  if (!visible) return null;

  return (
    <Button
      onClick={onClick}
      size="icon"
      className="fixed bottom-28 right-4 md:bottom-24 md:right-8 z-30 rounded-full shadow-lg h-10 w-10 animate-fade-in"
      variant="secondary"
    >
      <ChevronDown size={20} />
      {unreadCount > 0 && (
        <span className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-primary text-primary-foreground text-[10px] font-bold flex items-center justify-center">
          {unreadCount > 9 ? "9+" : unreadCount}
        </span>
      )}
    </Button>
  );
}
